const instanceMap = new Map()
const websocketMap = new Map()

const onOpen = function (event) {
  websocketMap.get(this).onWebsocketReady(event)
}

const onMessage = function (event) {
  try {
    websocketMap.get(this).onMessage(JSON.parse(event.data))
  } catch (error) {
    console.error(event)
  }
}

const onClose = function (event) {
  let websocketManager = websocketMap.get(this)
  websocketManager.removeEventListener(this)
  websocketManager.create()
}

class WebSocketManager {
  // websocket连接成功后的事件名
  static WEBSOCKET_READY = Symbol('onWebSocketReady')

  // websocket关闭后的事件名
  static WEBSOCKET_CLOSED = Symbol('onWebSocketClosed')

  connectNum = 1

  params
  websocket
  wmo
  ready = false
  eventMap = {}

  /**
   * 构造函数
   * @param websocketMessageOpt<WebSocketMessageOpt>  command, data的字段管理选项
   * @param wrapper<WebSocket>                        WebSocket实例
   * @param params<Array>                             构建WebSocket时的参数
   */
  constructor (wrapper, websocketMessageOpt, params) {
    this.wmo = websocketMessageOpt
    this.params = params
    this.create()
  }

  /**
   * 创建websocket
   */
  create () {
    let websocket = this.websocket = new window.WebSocket(...this.params)
    websocketMap.set(websocket, this)
    this.addEventListener(websocket)
  }

  /**
   * 关闭销毁websocket
   */
  close () {
    let {websocket} = this

    if (websocket) {
      this.removeEventListener(websocket)
      websocketMap.delete(websocket)
      websocket.close()
      this.websocket = null
    }

    this.emit(WebSocketManager.WEBSOCKET_CLOSED)

    this.eventMap = this.params = this.wmo = null
  }

  /**
   * 根据事件名添加websocket监听事件
   * @param eventName<String> 事件名
   * @param handler<Function> 监听函数
   */
  on (eventName, handler) {
    let {eventMap} = this
    let handlers = eventMap[eventName]

    if (!Array.isArray(handlers)) {
      handlers = eventMap[eventName] = []
    }

    handlers.push(handler)
  }

  /**
   * 根据事件名关闭对应的websocket监听事件
   * @param eventName<String> 事件名
   * @param handler<Function> 监听函数
   */
  off (eventName, handler) {
    let {eventMap} = this
    let handlers = eventMap[eventName]

    if (!Array.isArray(handlers)) {
      return
    }

    let index = handlers.indexOf(handler)

    if (index > -1) {
      handlers.splice(index, 1)
    }
  }

  /**
   * 根据事件名发布事件
   * @param eventName<String> 事件名
   * @param params            传给监听方法的参数
   */
  emit (eventName, ...params) {
    let handlers = this.eventMap[eventName]

    if (Array.isArray(handlers)) {
      handlers.forEach(handler => handler(...params))
    }

    params = null
  }

  /**
   * 当websocket连接完成后的事件
   * @param event 事件对象
   */
  onWebsocketReady (event) {
    this.ready = true
    this.emit(WebSocketManager.WEBSOCKET_READY, this.connectNum++)
  }

  /**
   * 当接收到websocket消息时的事件
   * @param data  websocket接收的消息对象
   */
  onMessage (data) {
    let {wmo} = this
    const errorHandler = wmo.errorHandlerMap[data.code]

    if (errorHandler) {
      this.destroy()
      errorHandler(new Error(data[wmo.msg]))
      return
    }
    this.emit(data[wmo.command], data[wmo.data])
  }

  /**
   * 发送websocket消息
   * @param command<String> 消息名
   * @param data<String>    数据
   */
  send (command, data) {
    let {wmo} = this
    let message = {
      [wmo.command]: command,
      [wmo.data]: data
    }
    this.websocket.send(JSON.stringify(message))
  }

  /**
   * 添加监听websocket的状态变化事件
   * @param websocket<WebSocket>  系统WebSocket实例
   */
  addEventListener (websocket) {
    websocket.addEventListener('open', onOpen)
    websocket.addEventListener('message', onMessage)
    websocket.addEventListener('close', onClose)
  }

  /**
   * 移除监听websocket的状态变化事件
   * @param websocket<WebSocket>  系统WebSocket实例
   */
  removeEventListener (websocket) {
    websocket.removeEventListener('open', onOpen)
    websocket.removeEventListener('message', onMessage)
    websocket.removeEventListener('close', onClose)
    this.ready = false
  }
}

export default class WebSocket {
  // websocket连接成功后的事件名
  static WEBSOCKET_READY = WebSocketManager.WEBSOCKET_READY

  // websocket关闭后的事件名
  static WEBSOCKET_CLOSED = WebSocketManager.WEBSOCKET_CLOSED

  /**
   * 构造函数
   * @param websocketMessageOpt<WebSocketMessageOpt>  command, data的字段管理选项
   * @param params                                    构建WebSocket时的参数
   */
  constructor (websocketMessageOpt, ...params) {
    instanceMap.set(this, new WebSocketManager(this, websocketMessageOpt, params))
  }

  /**
   * 根据事件名添加websocket监听事件
   * @param eventName<String> 事件名
   * @param handler<Function> 监听函数
   */
  on (eventName, handler) {
    if (handler instanceof Function) {
      instanceMap.get(this).on(eventName, handler)
    }
  }

  /**
   * 根据事件名关闭对应的websocket监听事件
   * @param eventName<String> 事件名
   * @param handler<Function> 监听函数
   */
  off (eventName, handler) {
    if (handler instanceof Function) {
      instanceMap.get(this).off(eventName, handler)
    }
  }

  /**
   * 发送websocket消息
   * @param command<String> 消息名
   * @param data<String>    数据
   */
  send (command, data) {
    instanceMap.get(this).send(command, data)
  }

  /**
   * 关闭销毁websocket
   */
  close () {
    instanceMap.get(this).close()
    instanceMap.delete(this)
  }
}



// WEBPACK FOOTER //
// ./src/utils/WebSocket/index.js